var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secCont"},[_c('div',{staticClass:"docs_inner"},[_c('h2',{staticClass:"secContTit"},[_vm._v(_vm._s(_vm.propsHelpContent.title))]),_c('div',{staticClass:"secContInner",domProps:{"innerHTML":_vm._s(_vm.propsHelpContent.contents)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }